import React from 'react';

const UserDetail = ({ userDetails }) => {
  return (
    <div className="text-sm">
      <p className="p-2 text-amber-500 font-bold">Customer Details</p>
      <div className="mb-4 bg-gay-100 p-4 rounded-lg shadow-lg">
        {userDetails ? (
          <>
            <p className="mb-2 text-black">
              <strong>Name:</strong> {userDetails.username}
            </p>
            <p className="mb-2 text-black">
              <strong>Phone:</strong> {userDetails.phone}
            </p>
            <p className="mb-2 text-black">
              <strong>Address:</strong> {userDetails.address}
            </p>
            <p className="mb-2 text-black">
              <strong>Order Time:</strong> {userDetails.time}
            </p>
            <p className="mb-2 text-black">
              <strong>Order Date:</strong> {userDetails.date}
            </p>
          </>
        ) : (
          <p className="text-black mb-3">No user details available</p>
        )}
      </div>
    </div>
  );
};

export default UserDetail;
